import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function MPaisa() {
  const blocks = useBlockRenderer('mpaisa') as Block[]
  return <BlockRenderer blocks={blocks} />
}
